// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2VO-j","footer":"ModalError_footer__2HU31"};